/**
 * Which milestone each task is listed under on a Milestones or Tasks tab.
 */

export interface TasksByMilestone<T> {
	/** Each milestone's tasks, keyed by milestone id, in the order given. */
	byMilestone: Map<string, T[]>;
	/**
	 * Tasks in no milestone, and tasks naming a milestone that is not in
	 * `milestones` -- so every task is listed somewhere.
	 */
	general: T[];
}

export function groupTasksByMilestone<
	T extends { milestoneId?: string | null },
>(tasks: T[], milestones: Array<{ id: string }>): TasksByMilestone<T> {
	const byMilestone = new Map<string, T[]>(
		milestones.map((milestone) => [milestone.id, []]),
	);
	const general: T[] = [];

	for (const task of tasks) {
		const group = task.milestoneId
			? byMilestone.get(task.milestoneId)
			: undefined;
		if (group) {
			group.push(task);
		} else {
			general.push(task);
		}
	}

	return { byMilestone, general };
}

/** The label of the group `groupTasksByMilestone` returns as `general`. */
export const GENERAL_TASKS_LABEL = "General Tasks";
